import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const LOGO = 'https://static.readdy.ai/image/9ddf36d056944457ba6d11db4bbe63a3/a79f7c4f392dd3eb1e2a6e263a44105a.jpeg';

const links = [
  { to: '/', label: 'Accueil' },
  { to: '/a-propos', label: 'À propos' },
  { to: '/solutions', label: 'Solutions' },
  { to: '/contact', label: 'Contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const isActive = (to: string) => (to === '/' ? pathname === '/' : pathname.startsWith(to));

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'}`}>
      <div className="w-full px-4 md:px-10 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img src={LOGO} alt="Godwin Logistics" className="w-12 h-12 object-contain" />
          <div className="leading-tight">
            <div className={`font-heading font-bold text-base md:text-lg ${scrolled ? 'text-foreground-900' : 'text-white'}`}>Godwin Logistics</div>
            <div className={`text-[11px] uppercase tracking-widest ${scrolled ? 'text-primary-600' : 'text-primary-300'}`}>& Services</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map(l => (
            <Link
              key={l.to}
              to={l.to}
              className={`text-sm font-medium cursor-pointer whitespace-nowrap transition ${
                scrolled
                  ? (isActive(l.to) ? 'text-primary-600' : 'text-foreground-800 hover:text-primary-500')
                  : (isActive(l.to) ? 'text-primary-300' : 'text-white/90 hover:text-primary-300')
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/contact" className="px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold whitespace-nowrap cursor-pointer transition">
            Demander un devis
          </Link>
        </div>

        <button onClick={() => setOpen(!open)} className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${scrolled ? 'text-foreground-900' : 'text-white'}`}>
          <i className={`ri-${open ? 'close' : 'menu'}-line text-2xl`}></i>
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-3">
          {links.map(l => (
            <Link key={l.to} to={l.to} className="text-foreground-800 text-sm font-medium py-2 cursor-pointer">{l.label}</Link>
          ))}
          <Link to="/contact" className="px-5 py-2.5 rounded-md bg-primary-500 text-white text-sm font-semibold text-center whitespace-nowrap cursor-pointer">Demander un devis</Link>
        </div>
      )}
    </header>
  );
}